module.exports = __webpack_public_path__ + "static/img/1-1.64a0056.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/1-1.png
// module id = IX19
// module chunks = 0